/** Query key factory for the auth feature. Keeps cache keys consistent. */
export const authKeys = {
  all: ['auth'] as const,
  me: () => [...authKeys.all, 'me'] as const,
  tenant: (id: string) => [...authKeys.all, 'tenant', id] as const,
}
